<template>
  <div class="home-container" style="height: 100%;">
    <div class="home-content" style="height: 100%;">
      <iframe style="width: 100%;height: 100%;" :src="xscUrl" scrolling="auto" frameborder="0"></iframe>
      <!-- 搜索 -->
      <!-- <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="订单编号"
                prop="billOrderNo"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.billOrderNo"
                  placeholder="请输入订单编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="选择时间" prop="time"  style="width: 80%">
                <el-date-picker
                  v-model="searchForm.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="是否销户"
                prop="phone"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.isXiaohu" placeholder="请选择">
                  <el-option
                    v-for="(item, ind) in XiaohuList"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="支付类型"
                prop="payType"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.payType" placeholder="请选择">
                  <el-option
                    v-for="(item, ind) in payTypeList"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="楼栋名称"
                prop="ridgepoleId"
                label-width="100px"
                style="width: 80%"
              >
                 <el-select
                  v-model="searchForm.ridgepoleId"
                  clearable filterable
                  placeholder="请选择楼栋"
                   @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="单元名称"
                prop="ridgepoleId"
                label-width="100px"
                style="width: 80%"
              >
                 <el-select
                  v-model="searchForm.unitId"
                  clearable filterable
                  placeholder="请选择单元"
                  @change="unitSelect"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>            
            <el-col :span="6">
              <el-form-item
                label="楼层名称"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-select
                  v-model="searchForm.floorId"
                  clearable filterable
                  placeholder="请选择楼层"
                >
                  <el-option
                    v-for="item in floorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="房间名称"
                prop="roomName"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.roomName"
                  placeholder="请输入房间名称"
                ></el-input>
              </el-form-item>
            </el-col>            
          </el-row>
           <el-row>
            <el-col :span="6">
              <el-form-item
                label="房屋信息"
                prop="keyword"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.keyword"
                  placeholder="请输入房屋信息"
                ></el-input>
              </el-form-item>
            </el-col>    
            <el-col :span="12">
              <el-form-item
                label="排序方式"
                prop="keyword"
                label-width="100px"
                style="width: 80%"
              >
                <el-radio-group v-model="sortType" @input="changeSort">
                  <el-radio :label="0">录入时间</el-radio>
                  <el-radio :label="1">缴费时间</el-radio>
                  <el-radio :label="2">房间号</el-radio>
                </el-radio-group>              
              </el-form-item>
            </el-col>                    
          </el-row>         
        </el-form>
      </div> -->
      <!-- <div style="margin: 20px">
        <el-button
          size="small"
          @click="onLoad(1)"
          type="primary"
          icon="el-icon-search"
          style="width: 90px"
          >搜索</el-button
        >
        <el-button
          size="small"
          @click="restSearch"
          type="danger"
          style="width: 90px"
          >重置</el-button
        >
        <el-button
          size="small"
          type="primary"
          style="width: 90px; margin-right: 15px"
          icon="el-icon-download"
        >
          <a :href="baseUrL" download style="color: #fff"
            >导出</a
          ></el-button
        >        
      </div> -->
      <!-- <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="billOrderNo" label="订单号" align="center">
        </el-table-column>
        <el-table-column prop="userName" label="缴费人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>        
        <el-table-column prop="address" label="房屋信息" align="center">
        </el-table-column>
        <el-table-column prop="cycleTime" label="缴费周期" align="center">
        </el-table-column>
        <el-table-column prop="billCategoryName" label="缴费类型" align="center">
        </el-table-column>
        <el-table-column prop="billPrice" label="缴费金额" align="center">
        </el-table-column>
        <el-table-column prop="payTime" label="缴费时间" align="center">
        </el-table-column>
        <el-table-column prop="payType" label="支付方式" align="center">
        </el-table-column>   
        <el-table-column prop="createTime" label="录入时间" align="center">
        </el-table-column>                
      </el-table> -->
            <!-- 分页器 -->
      <!-- <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import reg from '@/utils/reg'
export default {
  data() {
    return {
      searchForm: {
        billOrderNo: "",
        endTime: "",
        startTime: "",
        time: "",
        payType: "",
        ridgepoleId: "",
        unitId: "",
        floorId: "",
        roomName: "",
        billCategoryId: "",
        isXiaohu: "",
        sortType:0
      },
      XiaohuList: [
        {
          id: 1,
          name: "是",
        },
        {
          id: 0,
          name: "否",
        },
      ],
      payTypeList: [
        {
          id: 1,
          name: "微信线上",
        }, {
          id: 7,
          name: "微信线下",
        },
        {
          id: 2,
          name: "支付宝",
        },
        {
          id: 3,
          name: "现金",
        },
        {
          id: 4,
          name: "银行卡",
        },
        {
          id: 5,
          name: "对公转账",
        },{
          id: 6,
          name: "一卡通",
        },
      ],      
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ridgepoleList: [],
      unitList: [],
      floorList:[], 
      baseUrL:"" ,
      sortType:0 ,
      xscUrl:'https://szwy.zjwsrc.com/wyweb/#/paidPayment'   
    };
  },
  mounted() {
    this.xscUrl = this.xscUrl + '?userName=' + JSON.parse(localStorage.getItem('ToUserInfo')).account 
    this.baseUrL = process.env.VUE_APP_UPLOAD_REAL_PATH + "/export/bill?token=" + localStorage.getItem('zhi_token')
    this.onLoad();
  },
  methods: {
    // 排序搜索
    changeSort(e){
      this.sortType = e
      this.onLoad()
    },
    // 选择楼栋
    ridgepoleSelect(e) {
      this.$Apis.unitAllList({ ridgepoleId: e }).then((res) => {
        if (res.code == 200) {
          this.searchForm.unitId = ''
          this.searchForm.floorId = ''
          this.unitList = res.data;
        }
      });
    },
    // 选择单元
    unitSelect(e,row) {
      this.$Apis.floorAllList({ unitId: e }).then((res) => {
        if (res.code == 200) {
          this.floorList   = res.data;
          this.searchForm.floorId = ''
          if(row == 'updata'){
           this.isAddModal = true;
          }
        }
      });
    },     
    onLoad(ind) {
      this.isShowloading = true;
      this.isShowloading = true;
      let {billOrderNo,time,payType,ridgepoleId,unitId,floorId,roomName,billCategoryId,isXiaohu,keyword,sortType} = this.searchForm
      if(ind == 1){
        this.currentPage = 1
      }
     let page = {
        current: this.currentPage,
        size: this.pageSize,
        billOrderNo,
        endTime:reg.filterTime(time[1]),
        startTime:reg.filterTime(time[0]),
        payType,
        ridgepoleId,
        unitId,
        floorId,
        roomName,
        billCategoryId,
        isXiaohu,
        keyword,
        sortType:this.sortType
      };
      this.tableData = [];
      this.$Apis.houseAllList().then((res) => {
        if (res.code == 200) {
          this.ridgepoleList = res.data;
        }
      });      
      this.$Apis.billList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
          this.dialogVisible = false;
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.searchForm.sortType = 0
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    handleClick(row) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.billDel({id:row.id}).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg)
              this.onLoad()
            }else{
              this.$message.warning(res.msg)
            }
          })
        })

    },
  },
};
</script>

<style>
</style>